module.exports = __webpack_public_path__ + "img/avatar2.b52b6744.png";